/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface PagedResponse
 */
export interface PagedResponse extends Status {
    /**
     * 
     * @type {number}
     * @memberof PagedResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResponse
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResponse
     */
    totalRecords: number;
}

/**
 * Check if a given object implements the PagedResponse interface.
 */
export function instanceOfPagedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "pageSize" in value;
    isInstance = isInstance && "totalRecords" in value;

    return isInstance;
}

export function PagedResponseFromJSON(json: any): PagedResponse {
    return PagedResponseFromJSONTyped(json, false);
}

export function PagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'page': json['page'],
        'pageSize': json['pageSize'],
        'totalRecords': json['totalRecords'],
    };
}

export function PagedResponseToJSON(value?: PagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'page': value.page,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}

